import { getBrowserLocaleOverride, getCountryCodeOverride } from 'pricing-pages-ui-components/utils/debugOverrides';

// Skips I18N_MANUAL_LANG intentionally — that global reflects the proxy-served
// page language, not the user's browser locale. Mixing them causes the CHIRP
// cache key computed here to differ from the one the early requester computes,
// resulting in a duplicate RPC call.
export const getBrowserLocale = () => {
  const rawLocale = getBrowserLocaleOverride() || (navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language) || 'en-us';
  const browserLocale = rawLocale.toLowerCase();
  const preferredCountryCode = getCountryCodeOverride() || window.COUNTRY_CODE_FROM_LOCALE && window.COUNTRY_CODE_FROM_LOCALE.toUpperCase();
  return {
    browserLocale,
    preferredCountryCode
  };
};